import { FormlyFieldConfig } from "@ngx-formly/core";
import { Injector } from "@angular/core";
import { FieldDefinitionFields } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-fields";
import { FieldDefinitionConditions } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-conditions";
import { EntityEnum } from "../../../EntityEnum";
import { MedicinalProductsQueryNode } from "../../MedicinalProductsQueryNode";
import { Art57Section } from "../../../../Art57Section/Art57Section";
import { AutoUploadEntityEnum as AutoUploadEntityEnum } from "../../../../AutoUploadEntityEnum";
import { TreeNodeMasterFileLocationList } from "../../../Art57Node/ListEntity/TreeNodeMasterFileLocationList";

export class MasterFileLocationQueryNode extends MedicinalProductsQueryNode {
    constructor(injector: Injector) {
    const queryFields: FormlyFieldConfig[] =  new FieldDefinitionFields(injector).mflFields;
    const createChidTemplateParams = {nodeType: 1};
    const queryConditions: FormlyFieldConfig[] = new FieldDefinitionConditions(injector).mflConditions;
       super(injector, [], 'Master File Locations', EntityEnum.mfl,  queryFields, queryConditions, injector.get(Art57Section).medicinalProduct.masterfilelocationTreeNode, TreeNodeMasterFileLocationList ,AutoUploadEntityEnum.mfl, createChidTemplateParams);       
    }
}